import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { Armazem } from '../../types/estoque';
import { armazensService } from '../../services';

const columns: ResourceColumn<Armazem>[] = [
  { header: 'Nome', accessor: 'nome' },
  { header: 'Descrição', accessor: 'descricao' },
  { header: 'Endereço', accessor: 'endereco' },
  {
    header: 'Ativo',
    render: (item) => (item.ativo === false ? 'N\u00e3o' : 'Sim'),
  },
];

export const ArmazensListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
  <ResourceListPage
    title="Armazéns"
    description="Cadastro de armazéns para estocagem."
    columns={columns}
    service={armazensService}
    createPath="/admin/parametros/armazens/novo"
      onEdit={(item) => item.id && navigate("/admin/parametros/armazens/editar", { state: { record: item } })}
    searchPlaceholder="Buscar por nome/descri\u00e7\u00e3o..."
  />
  );
};